import { type ReactNode, useState } from "react";
import type { ToolsType } from "../../model/types";
import { useWorkspaceToolsStore } from "../store/useWorkspaceToolsStore";
import { type PanelScope, PanelScopeSwitcher } from "./PanelScopeSwitcher";
import { WorkspaceToolsPanelContent } from "./WorkspaceToolsPanelContent";

export type PanelScopeResult = {
	value: PanelScope;
	switcher: ReactNode | null;
	content: ReactNode | null;
};

export const usePanelScope = (type: ToolsType, onSwitch: () => void): PanelScopeResult => {
	const enabled = useWorkspaceToolsStore((store) => store.state.enabled);
	const [scope, setScope] = useState<PanelScope>("catalog");
	const [query, setQuery] = useState("");
	const value = enabled ? scope : "catalog";

	const switchTo = (next: PanelScope) => {
		setScope(next);
		setQuery("");
		onSwitch();
	};

	return {
		value,
		switcher: enabled ? <PanelScopeSwitcher onChange={switchTo} value={value} /> : null,
		content:
			value === "workspace" ? (
				<WorkspaceToolsPanelContent onQueryChange={setQuery} query={query} type={type} />
			) : null,
	};
};
